import React from "react";

const Popup = ({ content, handleClose }) => {
  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={handleClose}>×</button>
        {content}
      </div>
    </div>
  );
};

export default Popup;
